import { Button } from "@/components/Button"
import { ICard, TopUpContext, useCardList, useStoreCardView, useTopUpStore } from "@usher/pe-client-front-end-lib"
import { useContext, useEffect, useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Link, useHistory, useParams, useRouteMatch } from "react-router-dom"
import { CardSelect } from "../../components/CardSelect"

export const CardDetailsHeader = () => {
  const { $t: t } = useIntl()
  const { url } = useRouteMatch()
  const { cards } = useCardList()
  const isTransactions = url.indexOf("/transactions") > 0
  const navigate = useHistory()
  const setCardType = useTopUpStore((state) => state.setCardType)
  const { setCard } = useContext(TopUpContext)
  const { id } = useParams<{ id: string }>()

  const card = useStoreCardView((state) => state.card)
  const { status, type } = card
  const [selectedCard, setSelectedCard] = useState<ICard | null>(null)
  useEffect(() => {
    if (cards != null && cards.length > 0) {
      const foundCard = cards.find((card) => String(card.id) === String(id))
      if (foundCard != null) {
        setSelectedCard(foundCard)
      } else {
        setSelectedCard(cards[0])
      }
    }
  }, [id, cards])
  return (
    <>
      <div className="flex gap-3 items-start main-content_one-card_title flex-col lg:items-center lg:flex-row">
        <div className="max-w-[450px] w-full">
          <CardSelect
            cards={cards}
            value={selectedCard?.id}
            onChange={(v) => {
              if (v?.value != null) {
                setCard(v?.value)
                let path = `/cards/${v?.value}`
                if (isTransactions) path += "/transactions"
                navigate.push(path)
              }
            }}
          />
        </div>
        {(status as string) === "ACTIVE" && (
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              const cardTypes = ["Virtual", "Physical", "Own Card"]
              setCard(card)
              console.log("Card type is:", cardTypes[Number(card.type) - 1])
              setCardType(cardTypes[Number(card.type) - 1])
              navigate.push("/topup/by-crypto")
            }}
          >
            {t({ id: type === "3" ? "payout-to-card" : "top-up" })}
          </Button>
        )}
      </div>
      <div className="main-content_one-card_ul list !text-[14px]">
        <li className={!isTransactions ? "active" : ""}>
          <Link to={`/cards/${id}`}>
            <FormattedMessage id="card-details" />
          </Link>
        </li>
        <li className={isTransactions ? "active" : ""}>
          <Link to={`/cards/${id}/transactions`}>
            <FormattedMessage id="transactions" />
          </Link>
        </li>
      </div>
    </>
  )
}
